import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { SearchHeader } from '@ifca-root/react-component/src/components/Header/SearchHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { Box, IconButton, Typography } from '@material-ui/core'
import { KeyboardArrowRight } from '@material-ui/icons'
import { TreeView } from '@material-ui/lab'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import { StyledTreeItem } from 'containers/GeneralSettingModule/MasterCOA/RoleTreeStyle'
import { useGetStockCategoryQuery } from 'generated/graphql'
import { useFuseTreeSearch } from 'helpers/Hooks/useTreeSearch'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { CommonYupValidation } from 'helpers/YupSchema/yup'
import React, { useContext, useState } from 'react'
import { useHistory } from 'react-router'
import * as yup from 'yup'

export const StockItemTreeListing = (props: any) => {
  let history = useHistory()
  let user = JSON.parse(localStorage.getItem('loggedInUser'))
  const getSearch = localStorage?.getItem('searchFilter')
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )

  const [pageMode, setPageMode] = useState('')
  const [expandArray, setExpandArray] = useState([])
  const { filteredList, handleSearch, setOriginalListing } = useFuseTreeSearch()
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const StockCategoryFormSchema = yup.object().shape({
    Name: CommonYupValidation.requireField(SystemMsgs.name()),
    StockAccountCode: CommonYupValidation.requireField(
      SystemMsgs.stockAccountCode()
    ),
    ExpenseAccountCode: CommonYupValidation.requireField(
      SystemMsgs.expenseAccountCode()
    ),
  })

  const {
    loading: getStockCategoryLoading,
    data: { getStockCategory } = { getStockCategory: [] },
  } = useGetStockCategoryQuery({
    variables: { orderByAsc: 'Name' },
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ getStockCategory }) => {
      if (getStockCategory?.length > 0) {
        let initialArr = []
        let level = getStockCategory.map(v => v.Level).sort((a, b) => b - a)[0]
        initializeLevel(1, getStockCategory, initialArr, level, level)
        setOriginalListing(initialArr)
        setExpandArray(getStockCategory)
      }
    },
  })

  const initializeLevel = (level, data, arr, maxLevel, prtID) => {
    const dataToPush = data
      ?.filter(v => {
        if (v.ParentStockCategoryID !== null) {
          return v.Level === level && v.ParentStockCategoryID === prtID
        } else {
          return v.Level === level
        }
      })
      .map(x => {
        return {
          Name: x?.Name,
          StockCategoryID: x?.StockCategoryID,
          ParentStockCategoryID: x?.ParentStockCategoryID,
          Level: x?.Level,
          ISLastNode: x?.ISLastNode,
          ExpenseAccountCode: x?.ExpenseAccountCode,
          ExpenseAccountCodeID: x?.ExpenseAccountCodeID,
          StockItem: x?.StockItem,
          StockAccountCode: x?.StockAccountCode,
          StockAccountCodeID: x?.StockAccountCodeID,
          child: [],
        }
      })

    arr.push(...dataToPush)

    if (level < maxLevel) {
      arr.map(k => {
        initializeLevel(level + 1, data, k.child, maxLevel, k.StockCategoryID)
      })
    }
  }

  const renderTree = (nodes, index) => (
    <StyledTreeItem
      key={nodes?.StockCategoryID}
      nodeId={nodes?.StockCategoryID}
      label={
        <>
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: nodes?.Level === 0 ? null : '-15px',
            }}
            onClick={() =>
              history.push({
                pathname: `/inventory-control/general-setting/stock-item/${nodes?.StockCategoryID}`,
              })
            }
          >
            <Typography
              variant="body2"
              style={{
                fontWeight: 'inherit',
                flexGrow: 1,
                paddingTop: '5px',
                marginTop: '2px',
                paddingLeft: '20px',
                marginBottom: 'auto',
                paddingBottom:
                  nodes?.Level === 0 && filteredList[0]?.child?.length === 0
                    ? '5px'
                    : '7px',
              }}
            >
              <span className="xsTitle flex-space">{nodes.Name}</span>

              <div style={{ borderBottom: '1px solid #FF9800' }}>
                <span className="mdDesc">
                  {nodes?.StockItem?.length} Stock(s)
                </span>
              </div>
            </Typography>

            <IconButton>
              <KeyboardArrowRight
                onClick={() =>
                  history.push({
                    pathname: `/inventory-control/general-setting/stock-item/${nodes?.StockCategoryID}`,
                  })
                }
              />
            </IconButton>
          </Box>
        </>
      }
    >
      {Array.isArray(nodes.child)
        ? nodes.child.map((nodes, index) => renderTree(nodes, index))
        : null}
    </StyledTreeItem>
  )

  return (
    <>
      {getStockCategoryLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(`/inventory-control/general-setting/`)
          localStorage.removeItem('searchFilter')
        }}
        smTitle={'Inventory Control'}
        title={user?.accountName}
        routeSegments={[
          { name: 'General Setting' },
          //{ name: 'Company List' },
          { name: 'Stock Master File', current: true },
        ]}
        rightRouteSegments={[{ name: 'Category', current: true }]}
      />

      <div className="search-filter with-dropdown-filter ">
        <SearchHeader
          title={'Stock Category'}
          value={`${getStockCategory?.length}`}
          search
          onChangeAction={e => {
            handleSearch(e?.target?.value, [
              'Name',
              'StockItem.Name',
              'StockItem.Description',
            ])
            localStorage.setItem('searchFilter', e.target.value)
          }}
          defaultValue={getSearch ? getSearch : ''}
          onCloseAction={() => handleSearch('', [])}
          isDefaultValue={!!getSearch}
        />
      </div>

      {!getStockCategoryLoading && (
        <ContentWrapper float>
          <div>
            <CardContents>
              <TreeView
                className="tree-view-custom"
                expanded={expandArray?.map(x => x?.StockCategoryID)}
                multiSelect
              >
                {filteredList.map((el, index) => {
                  return renderTree(el, index)
                })}
              </TreeView>
            </CardContents>
          </div>
        </ContentWrapper>
      )}

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
